import {
  AlertModalController
} from './alert-modal.component';

export class AlertModalService {
  constructor($timeout, $modal) {
    this.$timeout = $timeout;
    this.$modal = $modal;
  }

  open(status, text, Null, isYes = false) {
    return this.$modal.open({
      template: require('./alert-modal.component.html'),
      controller: AlertModalController,
      resolve: {
        errorStatus: () => status,
        errorText: () => text,
        errorConfig: () => null,
        isYes: () => isYes,
      },
    }).result;
  }
}



// WEBPACK FOOTER //
// ./src/core/alert-modal/alert-modal.service.js